export const LANGUAGES = {
  plainText: {
    label: 'Plain Text',
    codeMirrorAccessorKey: 'text',
    shikiLang: 'text',
  },
  markdown: {
    label: 'Markdown',
    codeMirrorAccessorKey: 'markdown',
    shikiLang: 'markdown',
  },
  bash: { label: 'Bash', codeMirrorAccessorKey: 'shell', shikiLang: 'shell' },
  shell: { label: 'Shell', codeMirrorAccessorKey: 'shell', shikiLang: 'shell' },
  c: { label: 'C', codeMirrorAccessorKey: 'c', shikiLang: 'c' },
  cpp: { label: 'C++', codeMirrorAccessorKey: 'cpp', shikiLang: 'cpp' },
  csharp: { label: 'C#', codeMirrorAccessorKey: 'csharp', shikiLang: 'csharp' },
  css: { label: 'CSS', codeMirrorAccessorKey: 'css', shikiLang: 'css' },
  javascript: {
    label: 'JavaScript',
    codeMirrorAccessorKey: 'jsx',
    shikiLang: 'jsx',
  },
  jsx: { label: 'JSX', codeMirrorAccessorKey: 'jsx', shikiLang: 'jsx' },
  coffeescript: {
    label: 'CoffeScript',
    codeMirrorAccessorKey: 'coffeescript',
    shikiLang: 'coffeescript',
  },
  angular: {
    label: 'Angular',
    codeMirrorAccessorKey: 'angular',
    shikiLang: 'angular',
  },
  'css-extr': {
    label: 'CSS-Extr',
    codeMirrorAccessorKey: 'css',
    shikiLang: 'css',
  },
  diff: { label: 'Diff', codeMirrorAccessorKey: 'diff', shikiLang: 'diff' },
  git: { label: 'Git', codeMirrorAccessorKey: 'diff', shikiLang: 'diff' },
  graphql: {
    label: 'GraphQL',
    codeMirrorAccessorKey: 'graphql',
    shikiLang: 'graphql',
  },
  svelte: {
    label: 'Svelte',
    codeMirrorAccessorKey: 'svelte',
    shikiLang: 'svelte',
  },
  vue: { label: 'Vue', codeMirrorAccessorKey: 'vue', shikiLang: 'vue' },
  haskell: {
    label: 'Haskell',
    codeMirrorAccessorKey: 'haskell',
    shikiLang: 'haskell',
  },
  ruby: { label: 'Ruby', codeMirrorAccessorKey: 'ruby', shikiLang: 'ruby' },
  rust: { label: 'Rust', codeMirrorAccessorKey: 'rust', shikiLang: 'rust' },
  html: { label: 'HTML', codeMirrorAccessorKey: 'html', shikiLang: 'html' },
  dart: { label: 'Dart', codeMirrorAccessorKey: 'dart', shikiLang: 'dart' },
  java: { label: 'Java', codeMirrorAccessorKey: 'java', shikiLang: 'java' },
  lua: { label: 'Lua', codeMirrorAccessorKey: 'lua', shikiLang: 'lua' },
  go: { label: 'GO', codeMirrorAccessorKey: 'go', shikiLang: 'go' },
  r: { label: 'R', codeMirrorAccessorKey: 'r', shikiLang: 'r' },
  clojure: {
    label: 'Clojure',
    codeMirrorAccessorKey: 'clojure',
    shikiLang: 'clojure',
  },
  json: { label: 'JSON', codeMirrorAccessorKey: 'json', shikiLang: 'json' },
  less: { label: 'Less', codeMirrorAccessorKey: 'css', shikiLang: 'css' },
  objectivec: {
    label: 'Objective-C',
    codeMirrorAccessorKey: 'objectiveC',
    shikiLang: 'objective-c',
  },
  python: {
    label: 'Python',
    codeMirrorAccessorKey: 'python',
    shikiLang: 'python',
  },
  sass: { label: 'SASS', codeMirrorAccessorKey: 'sass', shikiLang: 'sass' },
  sql: { label: 'SQL', codeMirrorAccessorKey: 'sql', shikiLang: 'sql' },
  stylus: {
    label: 'Stylus',
    codeMirrorAccessorKey: 'stylus',
    shikiLang: 'stylus',
  },
  swift: {
    label: 'Swift',
    codeMirrorAccessorKey: 'swift',
    shikiLang: 'swift',
  },
  kotlin: {
    label: 'Kotlin',
    codeMirrorAccessorKey: 'kotlin',
    shikiLang: 'kotlin',
  },
  tsx: { label: 'TSX', codeMirrorAccessorKey: 'tsx', shikiLang: 'tsx' },
  typescript: {
    label: 'TypeScript',
    codeMirrorAccessorKey: 'javascript',
    shikiLang: 'javascript',
  },
  wasm: {
    label: 'WebAssembly',
    codeMirrorAccessorKey: 'wast',
    shikiLang: 'wasm',
  },
  yaml: { label: 'YAML', codeMirrorAccessorKey: 'yaml', shikiLang: 'yaml' },
  glsl: { label: 'GLSL', codeMirrorAccessorKey: 'glsl', shikiLang: 'glsl' },
  zig: { label: 'Zig', codeMirrorAccessorKey: 'zig', shikiLang: 'zig' },
  ocaml: { label: 'OCaml', codeMirrorAccessorKey: 'ocaml', shikiLang: 'ocaml' },
  mermaid: {
    label: 'Mermaid',
    codeMirrorAccessorKey: 'mermaid',
    shikiLang: 'mermaid',
  },
}

export type Language = keyof typeof LANGUAGES
